import React from "react";
import {
  TextField,
  InputProps,
  FilledInputProps,
  OutlinedInputProps,
} from "@mui/material";

type Color = "error" | "primary" | "secondary" | "info" | "success" | "warning";

interface IProps {
  color?: Color;
  value?: string;
  onKeyDown?: (event: any) => void;
  onChange?: (e: any) => void;
  InputProps?:
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>
    | Partial<InputProps>;
}

export const ReseachInput: React.FC<IProps> = ({
  value,
  onKeyDown,
  onChange,
  color,
  InputProps,
}) => {
  return (
    <TextField
      focused
      value={value}
      color={color}
      label="Pesquisar"
      onChange={onChange}
      onKeyDown={onKeyDown}
      InputProps={InputProps}
    />
  );
};
